/* eslint-disable react/jsx-filename-extension */
import { routePermission } from 'utils/permission';

// Authenticated Routes components
import configuracion from 'routes/configuracion';

// Authentication Routes components
import Login from 'views/Auth/Login/index';
import SolicitudRestablecerContrasena from 'views/Auth/SolicitudRestablecerContrasena';
import RecuperacionDeContrasena from 'views/Auth/RecuperacionDeContrasena';
import ActivarCuenta from 'views/Auth/ActivarCuenta';
import RestablecerContrasena from 'views/Auth/RestablecerContrasena';
import CancelarRestablecerContraseña from 'views/Auth/CancelarRestablecerContrasena';

export const initialRoutes = configuracion;

const normalizeRoutes = (_routes = [], parent = null) => _routes.map((r) => {
  const path = (`/${r.title}`).normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    .replace(/ /g, '-').toLowerCase();
  const children = r.children ? normalizeRoutes(r.children, r).filter((e) => e) : [];
  const permissionModel = r.permissionModel || parent?.permissionModel;
  const catalogsModels = r.catalogsModels || parent?.catalogsModels;
  if (children.length) {
    return {
      ...r,
      path,
      permissionModel,
      children,
    };
  }
  if (routePermission(path, permissionModel, catalogsModels)) {
    return {
      ...r,
      path,
      permissionModel,
    };
  }
  return null;
});

const _flatRoutes = (_routes, parentPath = '') => _routes.map((r) => {
  if (r.children) {
    return _flatRoutes(r.children, parentPath + r.path);
  }
  return {
    ...r,
    path: parentPath + r.path,
  };
});

export const flatRoutes = (_routes = []) => {
  let _flattedRoutes = _flatRoutes(_routes);
  while (_flattedRoutes.find((r) => Array.isArray(r))) {
    _flattedRoutes = _flattedRoutes.flat();
  }
  return _flattedRoutes;
};

export const getRoutes = () => normalizeRoutes(initialRoutes).filter((e) => e);

export const authRoutes = [
  {
    path: 'inicio-de-sesion',
    component: Login,
    withoutLayout: true,
  },
  {
    path: 'recuperar-contrasena',
    component: SolicitudRestablecerContrasena,
  },
  {
    path: 'recuperacion-de-contrasena',
    component: RecuperacionDeContrasena,
  },
  {
    path: 'activar-cuenta',
    component: ActivarCuenta,
  },
  {
    path: 'restablecer-contrasena',
    component: RestablecerContrasena,
  },
  {
    path: 'cancelar-restablecer-contrasena',
    component: CancelarRestablecerContraseña,
  },
];
